import axiosInstance from "@/lib/axios";
import {
    DowngradeCheckResponse,
    PaymentHistoryResponse,
    PlanResponse,
    StartTrialResponse,
    SubscriptionPurchaseResponse,
    SubscriptionStatusResponse
} from "../types/plan.types";


export const planServiceApi = {
    getPlans: async (): Promise<PlanResponse> => {
        const response = await axiosInstance.get<PlanResponse>(
            `/subscription/subscription-lists`
        );
        return response.data;
    },
    subscriptionPurchase: async (subscriptionId: string, billingCycle: string, chatBotId: string, autoPay = false): Promise<SubscriptionPurchaseResponse> => {
        const response = await axiosInstance.post<SubscriptionPurchaseResponse>(
            `/subscription/${subscriptionId}/purchase`,{
                billingCycle,
                chatBotId,
                autoPay
            }
        );
        return response.data;
    },
    startTrial: async (subscriptionId: string, chatBotId: string): Promise<StartTrialResponse> => {
        const response = await axiosInstance.post<StartTrialResponse>(
            `/subscription/${subscriptionId}/start-trial`,
            { chatBotId }
        );
        return response.data;
    },
    subscriptionStatus: async (orderId: string): Promise<SubscriptionStatusResponse> => {
        const response = await axiosInstance.get<SubscriptionStatusResponse>(
            `/subscription/check-status/${orderId}`
        );
        return response.data;
    },
    paymentHistory: async (chatBotId:string): Promise<PaymentHistoryResponse> => {
        const response = await axiosInstance.get<PaymentHistoryResponse>(
            `/subscription/payment-history?chatBotId=${chatBotId}`
        );
        return response.data;
    },
    downgradeCheck: async (subscriptionId: string,chatBotId:string): Promise<DowngradeCheckResponse> => {
        const response = await axiosInstance.get<DowngradeCheckResponse>(
            `/subscription/${subscriptionId}/downgrade-check/${chatBotId}`
        );
        return response.data;
    }
};
